<template>
  <section class='no-transition'>
    <div class="content scrollable">
      <div class="heading">
        <h2>{{ i18n.t(`GDPR:title`) }}</h2>
        <span v-if="GDPR.editGDPR" id="editGDPR" @click="confirm(false)" class="button">{{ i18n.t(`GDPR:edit`) }}</span>
      </div>
      <ul class="items">
        <li class="item" v-for="item in items" v-if="consent[item.namespace].consent && !item.hasHint">
            <div class="value" >
              - {{ i18n.t(`${copyNamespace}:${item.namespace}.item_text`, i18nNamespaceParams(item.namespace)) }} <a href="#" v-if="item.hasLink" @click.prevent="openModal(item.namespace)">{{ i18n.t(`GDPR:learn`) }} </a>
            </div>
        </li>
      </ul>
    </div>
    <div v-if="hintItem" class="continue">
      <div class="hint">
        <p v-if="['JP','CA'].includes(app.country.code)">{{ i18n.t(`${copyNamespace}:${hintItem.namespace}.item_text_policy`) }} <a href="#" v-if="hintItem.hasLink" @click.prevent="openModal(hintItem.namespace)">{{ i18n.t(`GDPR:here_hint`) }} </a></p>
        <p v-else>{{ i18n.t(`${copyNamespace}:${hintItem.namespace}.item_text`) }} <a href="#" v-if="hintItem.hasLink" @click.prevent="openModal(hintItem.namespace)">{{ i18n.t(`GDPR:here`) }} </a></p>
      </div>
    </div>
    <action-bar>
      <ul>
        <li @click="confirm" class="primary custom-primary" :class="{saving: isSaving}">
          <span>{{ i18n.t(`GDPR:confirm`) }}</span>
        </li>
      </ul>
    </action-bar>
    <modal :title="modalTitle" v-if="modalShown" @closeModal="closeModal" :content="modalContent" :url="privacyExternalLink" :externalContent="!!privacyExternalLink" />
  </section>
</template>

<style lang="scss" rel="stylesheet/scss" scoped>
@import "../assets/mixins";

ul {
  @include button-list;

  li {
    text-align: center;
    padding: 0;
  }
}
section {
  margin-top: 0 !important;

  & .content {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 100px;
    padding: 30px 30px;
    margin: -30px;
    margin-top: 30px;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;

    @media (max-width: #{$small-phone-width}) {
      bottom: 60px;
    }
  }
}
.modal-container {
  top: 0 !important;
  .content {
    padding: 30px;
  }
}

.heading {
  margin: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;
  h2 {
    font-family: $GDPRTextFontFamily;
    font-size: 25px;
    font-weight: bold;
    line-height: 32px;
    text-align: left;
    color: #1A212C;
  }
  .button {
    box-sizing: border-box;
    border: 1px solid $GDPRLinkColor;
    border-radius: 4px;
    color: $GDPRLinkColor;
    padding: 10px 20px;
    cursor: pointer;
    font-size: 14px;
  }
}

.items {
  list-style-type: none;
  margin: 20px -30px 50px;
  .item {
    padding: 2px 30px;
    margin: 0;
    font-size: 15px;
    font-family: $GDPRTextFontFamily;
    color: #798291;
    font-weight: $GDPRTextWeight;
    line-height: $GDPRTextLineHeight;
    text-align: left;
    white-space: pre-wrap;
    word-wrap: break-word;
    white-space: normal;
    & a {
      color: #798291;
      font-size: 14px;
      font-weight: $GDPRTextWeight;
    }
    cursor: initial
  }
}
.continue {
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;
  justify-content: flex-end;
  width: 100%;

  .hint {
    background: #EFF2F4;
    border-radius: 8px;
    padding: 10px 18px;
    font-size: 	15px;
    line-height: 1.3125rem;
    font-weight: 300;
    color: #798291;
    margin-bottom: 90px;
    width: calc(100% - 20px);
    z-index: 10;
    @include desktop {
      margin-bottom: 100px;
    }
    a {
      color: #798291;
    }
  }
}
</style>

<script>
import Vue from 'vue'
import { mapState } from 'vuex'
import ActionBar from '../components/ActionBar'
import ToggleButton from '../components/ToggleButton'

export default Vue.component('GDPR-screen', {
  components: {
    'action-bar': ActionBar,
    'toggle-button': ToggleButton
  },
  props: ['screenParams'],
  data () {
    const GDPRLevel = this.$store.state.GDPR.selected
    const copyNamespace = `${GDPRLevel}GDPR`
    const consent = this.$store.state.consent
    const items = this.$store.state.GDPR.modes[GDPRLevel]

    return {
      copyNamespace: copyNamespace,
      items,
      consent: consent,
      filters: [{ value: false }, { value: true }],
      modalTitle: '',
      modalContent: '',
      modalLink: '',
      modalShown: false,
      isSaving: false
    }
  },
  methods: {
    confirm (accept = true) {
      this.$store.dispatch('updateGDPR', {
        accepted: accept,
        acceptedFromPreGDPR: true
      })
      this.$store.dispatch('next', {...this.screenParams.nextScreenRoute, skipDelay: true})
    },
    setTermsContent (namespace) {
      if (['terms', 'privacy', 'sportTerms'].includes(namespace)) {
        const country = this.partner.country

        this.modalTitle = this.i18n.t(`${namespace}:title`)

        this.modalContent = typeof this.i18n.t(`${namespace}:content`) === 'string'
          ? this.i18n.t(`${namespace}:content`)
          : this.i18n.t(`${namespace}:content.${country}`) || this.i18n.t(`${namespace}:content.default`)

        this.modalLink = typeof this.i18n.t(`${namespace}:link`) === 'string'
          ? this.i18n.t(`${namespace}:link`)
          : this.i18n.t(`${namespace}:link.${country}`) || this.i18n.t(`${namespace}:link.default`)
      } else {
        this.modalTitle = this.i18n.t(`${this.copyNamespace}:${namespace}.link_title`)
        this.modalContent = this.i18n.t(`${this.copyNamespace}:${namespace}.link_content`)
        this.modalLink = ''
      }
    },
    openModal (namespace) {
      this.setTermsContent(namespace)
      if (this.modalLink && this.partner.externalLinks.enabled) {
        this.$postmate.emit('initExternalFrame', {
          title: this.modalTitle,
          src: this.modalLink
        })
      } else {
        this.modalShown = true
      }
    },
    closeModal () {
      this.modalShown = false
    },
    i18nNamespaceParams (namespace) {
      let paramsObj = {}

      if (namespace === 'age') {
        paramsObj.age = this.partner.minimumBirthAge[this.user.country] ? this.partner.minimumBirthAge[this.user.country] : this.partner.minimumBirthAge.default
      }

      return paramsObj
    }
  },
  computed: {
    ...mapState(['user', 'app', 'partner', 'GDPR']),
    privacyExternalLink () {
      const countryCode = this.partner.country
      const link = this.partner.externalLinks[this.modalNamespace] && this.partner.externalLinks[this.modalNamespace][countryCode]
      return link
    },
    hintItem () {
      const item = this.items.length > 0 && this.items.find(item => item.hasHint)
      return item
    }
  }
})
</script>



// WEBPACK FOOTER //
// src/screens/preGDPR.vue